export default "__VITE_ASSET__4A0l8ikk__"